module.exports = __webpack_public_path__ + "media/src/public/img/main-bg-2f37e072d615d89e86917ac4be964a9e.jpg";